import { post } from '../../../../../../../infra/rest';
import { FilterFieldValueRequestArgs, FilterFieldValueResponse } from '../typings';

export const getCustomFieldFilterFieldValues = async (
  args: FilterFieldValueRequestArgs,
  signal?: AbortSignal
): Promise<FilterFieldValueResponse> => {
  return post<FilterFieldValueResponse>(
    '/v4/search/filter-field-value',
    {
      body: JSON.stringify({
        fieldId: args.fieldId,
        search: args.search ?? '',
        searchAfter: args.searchAfter,
      }),
    },
    true,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );
};
